/* IE tarzı crossfade slider: Dawn'ın kaydırma mekaniği yerine
   slaytlar üst üste durur, opacity ile birbirine erir. */
(function () {
  function init(sc) {
    var slider = sc.querySelector('.slideshow');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.slideshow__slide'));
    if (slides.length < 2) return;

    sc.classList.add('ie-xfade');

    var dots = Array.prototype.slice.call(sc.querySelectorAll('.slider-counter__link'));
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = (parseFloat(slider.getAttribute('data-speed')) || 5) * 1000;
    var idx = Math.max(0, slides.findIndex(function (s) { return s.getAttribute('aria-hidden') !== 'true'; }));
    var timer = null;

    function show(n) {
      idx = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.classList.toggle('is-active', j === idx);
        s.setAttribute('aria-hidden', j === idx ? 'false' : 'true');
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('slider-counter__link--active', j === idx);
        if (j === idx) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }

    function restart() {
      if (!autoplay) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () { show(idx + 1); }, speed);
    }

    dots.forEach(function (d, j) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        show(j);
        restart();
      }, true);
    });

    // mobil kaydırma desteği
    var x0 = null;
    slider.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(idx + (dx < 0 ? 1 : -1)); restart(); }
      x0 = null;
    }, { passive: true });

    // fareyle üzerine gelince durakla
    sc.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    sc.addEventListener('mouseleave', restart);

    show(idx);
    restart();
  }

  function boot() {
    document.querySelectorAll('slideshow-component').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
